import React from 'react';
import Footer from '../../views/app/Footer';

const FooterContainer = () => {
  return <Footer />;
};

export default FooterContainer;
